import { Col, Row, Spin } from 'antd';
import DataGrid, {
  Column,
  Export,
  Grouping,
  Pager,
  Sorting,
  HeaderFilter,
  ColumnFixing,
  FilterRow,
  Paging,
  Lookup,
  Editing,
} from 'devextreme-react/data-grid';

import { ContractAPI } from '../../../Api/ContractAPI';
import { SignatureAPI } from '../../../Api/SignatureAPI';

import { useTableReadyToSend } from '../../../Hooks/useTableReadyToSend/useTableReadyToSend';

import { ITableReadyToSend } from './ITableReadyToSend';
import { LoadingOutlined } from '@ant-design/icons';
import { InvestorAPI } from '../../../Api/InvestorAPI';
import { NumericFormat } from 'react-number-format';
import moment from 'moment';

const TableReadyToSend = ({ baseURL, baseURLExternal, translations, clientId, language, moduleRole}: ITableReadyToSend) => {
	const contractAPI = ContractAPI(baseURL, baseURLExternal, clientId);
	const signaturitAPI = SignatureAPI(baseURL, clientId);
	const investorAPI = InvestorAPI(baseURL, baseURLExternal, clientId);

	const {
		loading,
		contractListData,
		cellRenderSendIcon,
		getFilteredSharesTypes,
		updateContract,
		onRowValidating,
		cellRenderCancelIcon,
		cellRenderEditIcon,
		onCellPrepared,
		cellRenderSendDate
	} = useTableReadyToSend({
		contractAPI,
		signaturitAPI,
		investorAPI,
		translations,
		moduleRole
	});

	const buildLocalHeaderFilterDataSource = (field: string) => () => {
		const values = contractListData
			.map((contract: any) => contract[field])
			.filter((value: any) => value !== null && value !== undefined && value !== '');

		return Array.from(new Set(values.map((value: any) => field === "created_At"
			? moment(value).format("YYYY-MM-DD")
			: value)))
			.map((value: any) => ({
				value,
				text: String(value)
			}));
	};

	return (
		<Row className="table-in-revision" justify="center">
			{contractListData ?
				<Col span={24}>
						<Spin
							spinning={loading}
							indicator={
							<LoadingOutlined style={{ fontSize: 34, color: "black" }} spin />
							}
						>
						<DataGrid
							id="table-in-revision-grid"
							showBorders={true}
							height={'75vh'}
							remoteOperations={true}
							allowColumnResizing={true}
							columnResizingMode={"widget"}
							columnMinWidth={80}
							rowAlternationEnabled={true}
							showRowLines={true}
							dataSource={contractListData}
							onRowUpdated={updateContract}
							hoverStateEnabled={true}
							dateSerializationFormat="dd/MM/yyyy"
							onRowValidating={(e: any) => onRowValidating(e)}
							onCellPrepared={onCellPrepared}
						>
							<HeaderFilter visible={true} />
							<Export enabled={true} />
							<Sorting mode="multiple" />
							<ColumnFixing enabled={true} />
							<FilterRow visible={true} />
							<Grouping contextMenuEnabled={true} expandMode="rowClick" />
							<Grouping autoExpandAll={false} />
							<Paging defaultPageSize={100} />
							
							<Pager
								showPageSizeSelector={true}
								allowedPageSizes={[20, 50, 100]}
								showNavigationButtons={true}
								visible={true}
								showInfo={true}
							/>
							<Editing
								mode="cell"
								useIcons={true}
								allowUpdating={moduleRole !== "Read"}
								allowDeleting={false}
							/>
							<Column dataField="id" caption="Contract ID" width={15} allowEditing={false} headerFilter={{ dataSource: buildLocalHeaderFilterDataSource("id") }}/>
							<Column dataField="investorName" caption={translations.nombre} allowEditing={false} alignment='center' headerFilter={{ dataSource: buildLocalHeaderFilterDataSource("investorName") }}/>
							<Column dataField="templateName" caption={translations.template} alignment='center' width={120} headerFilter={{ dataSource: buildLocalHeaderFilterDataSource("templateName") }}/>
							<Column dataField="commitment" caption={translations.compromiso} width={120} alignment='right' 
								headerFilter={{ dataSource: buildLocalHeaderFilterDataSource("commitment") }}
								cellRender={(row) =>                  
									<NumericFormat
										thousandSeparator={language === 'es' ? "." : ","}
										decimalSeparator={language === 'es' ? "," : "."}
										value={row.data.commitment}
										displayType={"text"}
										prefix={"€"}
									/>
								} 
							/>
							<Column dataField="state" caption={translations.estado} alignment='center' width={120}
								headerFilter={{ dataSource: buildLocalHeaderFilterDataSource("state") }}
								cellRender={(row) => {
									const state = row.data.state;
									return (
										<span>
											{translations[state] || state}
										</span>
									);
								}}
							/>
							<Column dataField="created_At" caption={translations.fecha} width={100} dataType="date" format="dd/MM/yyyy" allowEditing={false} alignment='center' headerFilter={{ dataSource: buildLocalHeaderFilterDataSource("created_At") }}/>
							<Column dataField="placementAgentName" caption={translations.distribuidor} allowEditing={false} alignment='center' headerFilter={{ dataSource: buildLocalHeaderFilterDataSource("placementAgentName") }}/>
							<Column dataField="idShareType" caption="Shares Type" allowSearch={false} allowFiltering={false} alignment='center' allowHeaderFiltering={false}>
								<Lookup dataSource={(data: any) => data ? getFilteredSharesTypes(data.data) : getFilteredSharesTypes(contractListData[0])} displayExpr="sharesType" valueExpr="idSharesType"/>
							</Column>
							<Column dataField="dispatchNotificationDate" caption="Send Date" alignment='center' allowEditing={false} headerFilter={{ dataSource: buildLocalHeaderFilterDataSource("dispatchNotificationDate") }} cellRender={(e: any) => cellRenderSendDate(e.data.dispatchNotificationDate, e.data.idContractState)}/>
							<Column caption="Cancel/Delete" cellRender={cellRenderCancelIcon} width={20} alignment='center' allowEditing={false} allowHeaderFiltering={false} />
							<Column caption="Edit" cellRender={cellRenderEditIcon} width={20} alignment='center' allowHeaderFiltering={false} />
							<Column caption="Send" cellRender={cellRenderSendIcon} width={150} alignment='center' allowHeaderFiltering={false}/>
						</DataGrid>
					</Spin>
{/* 					<Modal
						open={true}
					>
						<p>Are you sure you want to send the contract with the selected shares?</p>
					</Modal> */}
				</Col> 
				: null
			}
		</Row>
	);
};

export default TableReadyToSend;
